import { render, staticRenderFns } from "./_TodoDetail.vue?vue&type=template&id=20dd6531&scoped=true&"
import script from "./_TodoDetail.vue?vue&type=script&lang=js&"
export * from "./_TodoDetail.vue?vue&type=script&lang=js&"
import style0 from "./_TodoDetail.vue?vue&type=style&index=0&id=20dd6531&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20dd6531",
  null
  
)

export default component.exports